import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getMyReport } from '../api/dashboardApi'
import { isQueryReady, type DashboardQuery } from '../types'
import { DASHBOARD_REFRESH_MS, queryKeyParts } from './useActionDashboard'

/**
 * Raporum sunucu-durumu (068 — analiz §2). Yedi bölümün tamamı **bu tek sorgudan** beslenir → zaman
 * filtresi değiştiğinde hepsi birlikte yenilenir (analiz §2.11).
 *
 * <p>Kişi filtresi yoktur; kapsam sunucuda kimlikten çözülür. Anahtar yine {@link queryKeyParts} ile
 * kurulur (Yönetici Raporu ile aynı kural) — dönem/tarih değişimi iki panoda da aynı biçimde önbelleklenir.
 *
 * <p>`enabled` bayrağı görünmeyen panonun isteğini engeller: iki pano tek sayfada durur, yalnız
 * <b>aktif</b> olan veri çeker.
 *
 * <p><b>Otomatik yenileme: 30 saniye</b> (kullanıcı isteği 2026-08-19) — Yönetici Raporu ile <b>aynı</b>
 * aralık ({@link DASHBOARD_REFRESH_MS}). 077 §K9 "Yenile" butonunu yalnız Yönetici Raporu'ndan kaldırıp
 * Raporum'da bırakmıştı; iki pano arasındaki bu davranış farkı kaldırıldı. Tazelemenin görünen kanıtı
 * üstteki "Son Güncelleme" damgasıdır.
 *
 * <p><b>Sekme arka plandayken durur:</b> `refetchIntervalInBackground` verilMEZ (TanStack varsayılanı
 * `false`) → görünmeyen bir sekme sunucuyu 30 saniyede bir dürtmez. Pasif pano da (`enabled=false`)
 * aralık dolsa bile istek atmaz.
 */
export function useMyReport(query: DashboardQuery, enabled = true) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['my-report', i18n.language, ...queryKeyParts(query)],
    queryFn: () => getMyReport(query),
    enabled: enabled && isQueryReady(query),
    refetchOnWindowFocus: false,
    refetchInterval: DASHBOARD_REFRESH_MS,
    // Periyodik yoklama merkezî hata hunisinden (019) MUAFTIR: kullanıcı isteğiyle değil, arka planda
    // 30 saniyede bir çalışır ve başarısızlığın kullanıcıya görünen yüzeyi zaten satır-içi hata bandıdır
    // (`home-error`). Susturulmasaydı bir kesintide pano açık kaldığı sürece HER 30 SANİYEDE bir hata
    // toast'ı düşerdi — üstelik bandın üstüne. Aynı gerekçe ve aynı desen: `useUnreadCount` (058).
    meta: { suppressGlobalError: true },
  })
}
